// Données des versets du Coran fréquemment utilisés dans les compétitions
// Structure de données optimisée pour l'accès par hizb et le niveau de difficulté

const quranData = {
  // Les versets sont organisés par sourate et numéro de verset
  // Chaque verset a une fréquence d'apparition dans les compétitions (1-10)
  // Un poids plus élevé signifie qu'ils apparaissent plus fréquemment
  verses: [
    {
      surah: 1, // Al-Fatiha
      ayah: 1,
      arabic: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
      translation: "Au nom d'Allah, le Tout Miséricordieux, le Très Miséricordieux.",
      transliteration: "Bismi l-lahi r-rahmani r-rahimi",
      hizb: 1,
      frequency: 10
    },
    {
      surah: 2, // Al-Baqarah
      ayah: 255, // Ayat Al-Kursi
      arabic: "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ",
      translation: "Allah, point de divinité à part Lui, le Vivant, Celui qui subsiste par Lui-même. Ni somnolence ni sommeil ne Le saisissent. À Lui appartient tout ce qui est dans les cieux et sur la terre. Qui peut intercéder auprès de Lui sans Sa permission? Il connaît leur passé et leur futur. Et de Sa science, ils n'embrassent que ce qu'Il veut. Son Trône déborde les cieux et la terre, dont la garde ne Lui coûte aucune peine. Et Il est le Très Haut, le Très Grand.",
      transliteration: "Allahu la ilaha illa huwa l-hayyu l-qayyumu la ta'khuthuhu sinatun wa la nawmun lahu ma fi s-samawati wa ma fi l-ardi man dha lladhi yashfa'u 'indahu illa bi-idhnihi ya'lamu ma bayna aydihim wa ma khalfahum wa la yuhituna bi-shay'in min 'ilmihi illa bi-ma sha'a wasi'a kursiyyuhu s-samawati wa l-arda wa la ya'uduhu hifzuhuma wa huwa l-'aliyyu l-'azimu",
      hizb: 5,
      frequency: 10
    },
    {
      surah: 36, // Ya-Sin
      ayah: 1,
      arabic: "يس",
      translation: "Ya Sin",
      transliteration: "Ya Sin",
      hizb: 30,
      frequency: 9
    },
    {
      surah: 67, // Al-Mulk
      ayah: 1,
      arabic: "تَبَارَكَ الَّذِي بِيَدِهِ الْمُلْكُ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
      translation: "Béni soit Celui dans la main de qui est la royauté, et Il est Omnipotent.",
      transliteration: "Tabaraka lladhi biyadihi l-mulku wa huwa 'ala kulli shay'in qadirun",
      hizb: 60,
      frequency: 9
    },
    {
      surah: 18, // Al-Kahf
      ayah: 1,
      arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَنْزَلَ عَلَىٰ عَبْدِهِ الْكِتَابَ وَلَمْ يَجْعَلْ لَهُ عِوَجًا",
      translation: "Louange à Allah qui a fait descendre sur Son serviteur le Livre et n'y a point introduit de tortuosité.",
      transliteration: "Al-hamdu lillahi lladhi anzala 'ala 'abdihi l-kitaba wa lam yaj'al lahu 'iwajan",
      hizb: 15,
      frequency: 8
    },
    {
      surah: 55, // Ar-Rahman
      ayah: 1,
      arabic: "الرَّحْمَٰنُ",
      translation: "Le Tout Miséricordieux",
      transliteration: "Ar-Rahmanu",
      hizb: 60,
      frequency: 8
    },
    {
      surah: 112, // Al-Ikhlas
      ayah: 1,
      arabic: "قُلْ هُوَ اللَّهُ أَحَدٌ",
      translation: "Dis: 'Il est Allah, Unique.'",
      transliteration: "Qul huwa llahu ahadun",
      hizb: 60,
      frequency: 7
    },
    {
      surah: 4, // An-Nisa
      ayah: 1,
      arabic: "يَا أَيُّهَا النَّاسُ اتَّقُوا رَبَّكُمُ الَّذِي خَلَقَكُمْ مِنْ نَفْسٍ وَاحِدَةٍ وَخَلَقَ مِنْهَا زَوْجَهَا وَبَثَّ مِنْهُمَا رِجَالًا كَثِيرًا وَنِسَاءً ۚ وَاتَّقُوا اللَّهَ الَّذِي تَسَاءَلُونَ بِهِ وَالْأَرْحَامَ ۚ إِنَّ اللَّهَ كَانَ عَلَيْكُمْ رَقِيبًا",
      translation: "Ô hommes! Craignez votre Seigneur qui vous a créés d'un seul être, et a créé de celui-ci son épouse, et qui de ces deux-là a fait répandre beaucoup d'hommes et de femmes. Craignez Allah au nom duquel vous vous implorez les uns les autres, et craignez de rompre les liens du sang. Certes Allah vous observe parfaitement.",
      transliteration: "Ya ayyuha n-nasu ttaqu rabbakumu lladhi khalaqakum min nafsin wahidatin wa khalaqa minha zawjaha wa baththa minhuma rijalan kathiran wa nisa'an wa ttaqu llaha lladhi tasa'aluna bihi wa l-arhama inna llaha kana 'alaykum raqiban",
      hizb: 10,
      frequency: 7
    },
    {
      surah: 3, // Al-Imran
      ayah: 1,
      arabic: "الم",
      translation: "Alif, Lam, Mim.",
      transliteration: "Alif Lam Mim",
      hizb: 10,
      frequency: 6
    },
    {
      surah: 78, // An-Naba
      ayah: 1,
      arabic: "عَمَّ يَتَسَاءَلُونَ",
      translation: "Sur quoi s'interrogent-ils mutuellement?",
      transliteration: "'Amma yatasa'aluna",
      hizb: 30,
      frequency: 6
    }
  ],
  
  // Définition des niveaux
  levels: [
    { id: 1, name: "1 Hizb", value: 1, description: "Premier niveau - 1 Hizb" },
    { id: 2, name: "2 Hizb", value: 2, description: "Niveau débutant facile - 2 Hizb" },
    { id: 5, name: "5 Hizb", value: 5, description: "Niveau débutant - 5 Hizb" },
    { id: 10, name: "10 Hizb", value: 10, description: "Niveau intermédiaire - 10 Hizb" },
    { id: 15, name: "15 Hizb", value: 15, description: "Niveau intermédiaire avancé - 15 Hizb" },
    { id: 20, name: "20 Hizb", value: 20, description: "Niveau moyen-avancé - 20 Hizb" },
    { id: 30, name: "30 Hizb", value: 30, description: "Niveau avancé - 30 Hizb" },
    { id: 60, name: "60 Hizb", value: 60, description: "Niveau expert - 60 Hizb (Coran complet)" }
  ],
  
  // Fonction pour obtenir des versets par niveau
  getVersesByLevel: (level) => {
    // Filtrer les versets dont le hizb est inférieur ou égal au niveau
    return quranData.verses.filter(verse => verse.hizb <= level);
  },
  
  // Fonction pour obtenir un verset aléatoire en fonction du niveau et pondéré par la fréquence
  getRandomVerseByLevel: (level) => {
    const availableVerses = quranData.getVersesByLevel(level);
    
    // Créer un tableau pondéré basé sur la fréquence
    let weightedVerses = [];
    availableVerses.forEach(verse => {
      // Ajouter le verset plusieurs fois en fonction de sa fréquence
      for (let i = 0; i < verse.frequency; i++) {
        weightedVerses.push(verse);
      }
    });
    
    // Sélectionner un verset aléatoire parmi le tableau pondéré
    const randomIndex = Math.floor(Math.random() * weightedVerses.length);
    return weightedVerses[randomIndex];
  },
  
  // Fonction pour obtenir les versets suivants d'un verset donné
  getNextVerses: (surah, ayah, count = 3) => {
    // Trouver tous les versets de la même sourate
    const surahVerses = quranData.verses.filter(verse => verse.surah === surah);
    
    // Trier les versets par numéro de verset
    surahVerses.sort((a, b) => a.ayah - b.ayah);
    
    // Trouver l'index du verset actuel
    const currentIndex = surahVerses.findIndex(verse => verse.ayah === ayah);
    
    if (currentIndex === -1) {
      return [];
    }
    
    // Récupérer les "count" versets suivants
    const nextVerses = [];
    for (let i = 1; i <= count; i++) {
      if (currentIndex + i < surahVerses.length) {
        nextVerses.push(surahVerses[currentIndex + i]);
      } else {
        // Si nous atteignons la fin de la sourate, essayons de récupérer des versets de la sourate suivante
        const nextSurah = surah + 1;
        const nextSurahVerses = quranData.verses.filter(verse => verse.surah === nextSurah);
        
        if (nextSurahVerses.length > 0) {
          // Trier les versets de la sourate suivante
          nextSurahVerses.sort((a, b) => a.ayah - b.ayah);
          
          // Ajouter les premiers versets de la sourate suivante
          const remainingCount = count - nextVerses.length;
          for (let j = 0; j < remainingCount && j < nextSurahVerses.length; j++) {
            nextVerses.push(nextSurahVerses[j]);
          }
        }
        
        break;
      }
    }
    
    return nextVerses;
  }
};

export default quranData;
